import React from 'react';
import Widget from 'components/Widget/Widget';
import IntegrationData from './components/IntegrationData';
import PropTypes from 'prop-types';
import { integrationMetricList } from 'modules/DashboardModule/charts/components/IntegrationMetricList';

const IntegrationQuickReports = (props) => {
  const { data, index, height, configuration, load_chart } = props;

  const widgetKey =
    data?.defaultFilter?.integration_type + 'widget' + index || 'revenue_widget_' + index;

  return (
    <Widget
      className='h-full'
      widget_key={widgetKey}
      showIntegrationFilters={data?.defaultFilter?.integration_type !== 'custom' ? true : false}
      title={data.title}
      index={index}
      disableLimit
      disableStatusFilter
      disableAccountsFilter
      disableLevelFilter
      data={data}
      default_filter={data?.defaultFilter}
      configuration={configuration}
      showWidgetTypeSwitcher
      load_chart={load_chart}
      metricsList={integrationMetricList}
      showCustomDesign
      changeAreaChartDesign
      showAllMetrics
      icon={
        data?.defaultFilter?.integration_type ? (
          <img
            src={`/icons/integrations/${data?.defaultFilter?.integration_type}.svg`}
            className='w-7 h-7 ml-2'
          />
        ) : (
          <img src='/icons/integrations/revenue.svg' className='w-5 h-5 ml-2' />
        )
      }
      position={data?.position}
      dashboard_widget_key={data?.key}
    >
      <IntegrationData height={height} data={data} widget_key={widgetKey} />
    </Widget>
  );
};

export default IntegrationQuickReports;

IntegrationQuickReports.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};
